import { render, staticRenderFns } from "./chengHeader.vue?vue&type=template&id=4c1ed536&scoped=true&"
import script from "./chengHeader.vue?vue&type=script&lang=js&"
export * from "./chengHeader.vue?vue&type=script&lang=js&"
import style0 from "./chengHeader.vue?vue&type=style&index=0&id=4c1ed536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ed536",
  null
  
)

export default component.exports